export default {
  application: {
    attachments: [],
    competencies: [],
    links: [],
    additionalFieldResponses: [],
  },

  candidate: {
    attachments: [],
    competencies: [],
    links: [],
  },

  chosenInterview: {},

  comment: {
    comment: '',
  },

  company: {
    photo: null,
    logo: null,
    language: null,
    name: '',
    slug: '',
    careersSlogan: '',
    competencyNames: [],
    liveInterviewEvaluationScales: {},
    features: {},
    branding: {},
    emailReplyTo: {
      name: '',
      email: '',
    },
  },

  previewCandidate: {
    name: '',
    phone: '',
    email: '',
    agreeTOS: false,
    link: '',
    city: '',
    attachments: [],
    additionalFieldResponses: [],
    atsCandidateId: '',
  },

  interview: {
    photo: null,
    logo: null,
    title: '',
    formSetup: {
      name: { visible: true, required: true },
      email: { visible: true, required: true },
      phoneNumber: {},
      city: {},
      attachments: {},
      links: {},
    },
    emailReplyTo: {
      email: '',
      name: '',
    },
    questions: [],
    competencyNames: [],
    chosenCandidates: [],
    additionalFormFields: [],
  },

  interviewAdd: {
    attachToJobAd: null,
    filter: '',
    id: null,
  },

  interviewInvite: {
    addresses: [],
    subject: '',
    greeting: '',
    defaultGreeting: '',
    message: '',
    name: '',
    endTime: '',
  },

  introduce: {
    emails: [],
    subject: '',
    message: '',
    name: '',
    informations: [],
  },

  invitationMessage: {
    subject: '',
    message: '',
    greeting: '',
    defaultGreeting: '',
    name: '',
    language: '',
    templateName: '',
  },

  emailTemplate: {
    subject: '',
    message: '',
    greeting: '',
    defaultGreeting: '',
    name: '',
    language: '',
    templateName: '',
  },

  jobAd: {
    draft: false,
    id: null,
    photo: null,
    logo: null,
    title: '',
    description: '',
    competencyNames: [],
    additionalFormFields: [],
    company: {},
    location: '',
    formSetup: {
      name: { visible: true, required: true },
      email: { visible: true, required: true },
      phoneNumber: {},
      city: {},
      coverLetter: {},
      attachments: {},
      links: {},
      questions: {},
    },
    video: null,
    questions: [],
    jobOpenings: [],
    listings: [],
    scheduling: {
      timeSelections: {},
      selectedTimeSlots: [],
    },
    schedulingMessage: {
      subject: '',
      message: '',
      greeting: '',
      name: '',
    },
  },

  live: {
    startTime: '',
    interviewers: [],
    candidates: [],
    candidateName: '',
    title: '',
    messageTitle: '',
    message: '',
    language: '',
    company: '',
  },

  login: {
    email: '',
    password: '',
  },

  register: {
    email: '',
  },

  forgotPassword: {
    email: '',
  },

  changePassword: {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  },

  question: {
    textQuestion: '',
    evaluationCriteria: '',
  },

  search: {
    query: '',
    results: {},
  },

  hashtags: {
    tag: '',
    tags: [],
  },

  showInvitationModal: false,
  singleApplication: {},

  team: {
    admins: [],
    inputValue: '',
  },

  emailReplyTo: {
    name: '',
    email: '',
  },

  videos: {
    ids: {},
  },

  usersAdd: {
    emails: [],
    language: '',
    permissions: {
      editUsers: false,
      account: false,
      billing: false,
      seeAllPositions: false,
      createJobPositions: false,
      createInterviews: false,
      reporting: false,
      default: true,
    },
  },

  companyDefaultPermissionsEdit: {
    editUsers: false,
    account: false,
    billing: false,
    seeAllPositions: false,
    createJobPositions: false,
    createInterviews: false,
    reporting: false,
  },

  usersPermissionsEditMatrix: {
    users: [],
    hasChanged: false,
  },

  user: {
    excludeFrom: [],
  },

  account: {
    name: '',
    signature: '',
  },

  SsoLogin: {
    email: '',
  },

  interviewGuide: {
    title: '',
    description: '',
    steps: [],
    language: '',
  },
  interviewRound: {
    title: '',
    description: '',
    language: '',
    admins: [],
    interviewGuide: null,
    candidates: [],
    candidateNames: {},
    inviteModalMessage: {
      subject: '',
      message: '',
      greeting: '',
      defaultGreeting: '',
      name: '',
    },
  },
}
